import { Control } from 'ol/control.js'
import mapMarker from '../../assets/location.svg'

const LocationControl = (function (Control) {
  function LocationControl (opt_options) {
    const options = opt_options || {}

    const button = document.createElement('button')
    button.innerHTML = `<img class="ol-location" src="${mapMarker}">`
    // window.IconicJS().inject('.location-icon')
    this.element = document.createElement('div')
    this.element.className = 'go-to-location ol-unselectable ol-control'
    this.element.appendChild(button)
    this.element.style.top = '65pt'
    this.element.style.left = '0.5em'
    this.located = false

    Control.call(this, {
      element: this.element,
      target: options.target
    })

    button.addEventListener('click', () => {
      if (this.handleLocation) this.handleLocation()
    }, false)
  }

  if (Control) LocationControl.__proto__ = Control
  LocationControl.prototype = Object.create(Control && Control.prototype)
  LocationControl.prototype.constructor = LocationControl

  LocationControl.prototype.setLocated = function(located) {
    this.located = located
    this.updateBorderStyle()
  }

  LocationControl.prototype.updateBorderStyle = function() {
    if (this.located) {
      this.element.classList.remove('go-to-location--not-located')
      this.element.classList.add('go-to-location--located')
    } else {
      this.element.classList.remove('go-to-location--located')
      this.element.classList.add('go-to-location--not-located')
    }
  }

  return LocationControl
}(Control))

export default LocationControl
